import { useEffect, useState } from "react";
import {
  CircularProgress,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  formControl: { backgroundColor: theme?.palette?.background.paper },
  category: {
    color: theme?.palette?.secondary?.main,
    fontWeight: "bold",
    opacity: "1 !important",
  },
  selectFlex: {
    "& .MuiSelect-select": {
      display: "flex",
    },
  },
}));

export default function LeaguePicker({
  label,
  name,
  value,
  handleChange,
  leagues,
  touched,
  error,
}) {
  const classes = useStyles();
  const [items, setItems] = useState([]);
  useEffect(() => {
    const check = async () => {
      var itemArray = [];
      var gameSystem = "";
      if (leagues) {
        leagues.forEach((league) => {
          if (gameSystem !== league.gameSystem.name) {
            gameSystem = league.gameSystem.name;
            itemArray.push(
              <MenuItem disabled value="" className={classes.category}>
                {gameSystem}
              </MenuItem>
            );
          }
          itemArray.push(
            <MenuItem key={league.id} value={league.id}>
              {league.name}
            </MenuItem>
          );
        });
      }
      setItems(itemArray);
    };
    check();
    // eslint-disable-next-line
  }, [leagues]);

  if (!leagues) {
    return (
      <TextField
        disabled
        label={label || "Circuit"}
        variant="outlined"
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <CircularProgress />
            </InputAdornment>
          ),
        }}
      />
    );
  }
  return (
    <FormControl
      fullWidth
      variant="outlined"
      className={classes.formControl}
      sx={{ mt: 2, mb: 1 }}
    >
      <InputLabel id={`${name}-label`}>{label || "Circuit"}</InputLabel>
      <Select
        error={Boolean(touched && error)}
        fullWidth
        helperText={touched && error}
        labelId={`${name}-label`}
        name={name}
        value={value}
        onChange={handleChange}
        label={label || "Circuit"}
        variant="outlined"
      >
        {items &&
          items.map((league) => {
            return league;
          })}
      </Select>
    </FormControl>
  );
}
